import React from 'react';
import { ExclamationTriangle, ArrowClockwise } from 'react-bootstrap-icons';
import { useLocale } from '../i18n/LocaleContext';
import './PageErrorBoundary.scss';

// A page that throws while rendering shows this instead of a white screen:
// what happened in one line and "Újratöltés". Around every dashboard page
// (Dashboard.js, keyed by the page so another page in the menu renders
// fresh) and once around the whole app (App.js) for anything outside it.

function Fallback({ full }) {
  const { t } = useLocale();
  return (
    <div className={`page-error${full ? ' page-error--full' : ''}`} role="alert" data-testid="page-error">
      <ExclamationTriangle size={22} className="page-error__icon" aria-hidden="true" />
      <h2 className="page-error__title">{t('pageError.title')}</h2>
      <p className="page-error__body">{t('pageError.body')}</p>
      <button type="button" className="btn-o btn-o--dark btn-o--sm" onClick={() => window.location.reload()}>
        <ArrowClockwise size={14} aria-hidden="true" />
        {t('pageError.reload')}
      </button>
    </div>
  );
}

export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[partners] page crashed:', error, info?.componentStack);
  }

  render() {
    if (this.state.error) return <Fallback full={this.props.full} />;
    return this.props.children;
  }
}
